import { Component, inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PopupService } from '@app/shared/services/popup.service';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { ActionIcons } from '@cds/ng-themes';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@app/core/services/session-storage.service';

@Component({
  selector: 'app-return-to-claim',
  imports: [ TranslateModule, CdsIconModule],
  templateUrl: './return-to-claim.component.html',
  styleUrl: './return-to-claim.component.scss'
})
export class ReturnToClaimComponent implements OnDestroy {
  storage = inject(SessionStorageService);
  // Icons
  readonly downloadIcon = ActionIcons.button_left_outlined;
  translateData: any;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private popupService: PopupService,
  ) { 
    // this.translate.use('ja');
    // this.translate.get('DIALOGS.END_CLAIM_CONFIRMATION').subscribe(resp => {
    //   this.translateData = resp;
    // })
  }

  showEndClaimConfirmation() {
    const title = this.translate.instant('DIALOGS.END_CLAIM_CONFIRMATION.TITLE');
    const message = this.translate.instant('DIALOGS.END_CLAIM_CONFIRMATION.MESSAGE');
    const stayButton = this.translate.instant('DIALOGS.END_CLAIM_CONFIRMATION.BUTTONS.STAY_BUTTON');
    const endButton = this.translate.instant('DIALOGS.END_CLAIM_CONFIRMATION.BUTTONS.END_BUTTON');

    const dialogRef = this.popupService.open({
      title,
      content: message,
      size: 'large',
      mobilePosition: 'bottom',
      mobileHeight: 'auto',
      showCloseButton: false,
      buttons: [
        {
          label: stayButton,
          style: 'secondary',
          action: () => {
            // console.log('Submission cancelled');
          },
          closeOnClick: true
        },
        {
          label: endButton,
          style: 'primary',
          action: async () => {
            // ✅ Navigate to eclaim top
            await this.router.navigate(['/eclaim']);
          },
          closeOnClick: true,
          loading: true // Show spinner during action
        }
      ]
    });
  }

  ngOnDestroy(): void {
    this.popupService.closeAll();
  }

}
